import { Modal, Typography } from 'antd';
import styles from './SharingSocialMedia.module.less';
import facebookIcon from '../../assets/images/icons/FACEBOOK_icon.svg';
import instagramIcon from '../../assets/images/icons/INTA_icon.svg';
import twitterIcon from '../../assets/images/icons/TWITTER_icon.svg';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/CLOSE.svg';
import { useImageUpload } from '../../hooks/useImageUpload';
import { useEffect, useState } from 'react';
import loading from '../../assets/images/composiciones_loading.svg';
import ShowIf from '../UI/ShowIf';

const { Paragraph } = Typography;

interface SharingSocialMediaI {
  isVisible: boolean;
  onSetVisible: (state: boolean) => void;
  imageBase64: string | null;
}

function SharingSocialMedia(props: SharingSocialMediaI) {
  const [socialMediaKey, setSocialMediaKey] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [imgPublicUrl, errorUpload, setImageBase64, cancelUpload] = useImageUpload();

  useEffect(() => {
    if (!imgPublicUrl) {
      return;
    }
    setIsLoading(false);
  }, [imgPublicUrl]);

  useEffect(() => {
    if (!props.isVisible) {
      return;
    }
    setImageBase64(props.imageBase64);
    setIsLoading(true);
  }, [props.isVisible]);

  useEffect(() => {
    if (!socialMediaKey || !imgPublicUrl) {
      return;
    }

    const sharerBaseUrl: any = {
      facebook: (url: string, msg: string) =>
        `https://www.facebook.com/sharer/sharer.php?u=${url}&hashtag=${msg}`,
      twitter: (url: string, msg: string) =>
        `https://twitter.com/intent/tweet?url=${url}&text=${msg}`,
      instagram: () => `https://www.instagram.com/explore/tags/ArtistaDeArchivoBPP/`,
    };
    const url = sharerBaseUrl[socialMediaKey](
      encodeURIComponent(imgPublicUrl),
      encodeURIComponent('#ArtistaDeArchivoBPP')
    );
    window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
    setSocialMediaKey(null);
    setIsLoading(false);
  }, [socialMediaKey, imgPublicUrl]);

  const handleShare = (socialMediaKey: 'facebook' | 'twitter' | 'instagram') => {
    setSocialMediaKey(socialMediaKey);
  };

  const handleCancel = () => {
    props.onSetVisible(false);
    setImageBase64(null);
    setIsLoading(false);
    cancelUpload();
  };

  return (
    <Modal
      width={450}
      wrapClassName="sharing-social-media"
      closeIcon={<CloseIcon />}
      footer={null}
      title={null}
      onCancel={handleCancel}
      visible={props.isVisible}
    >
      <div
        className={`${styles['sharing-social-media--bg-texture']} sm:pb-8 flex flex-wrap justify-center rounded-md`}
      >
        <img alt="Loading" className={`w-1/2 ${isLoading ? '' : 'hidden'}`} src={loading} />
        <div
          className={`${styles['sharing-social-media--bg-frame']} ${
            isLoading ? 'hidden' : ''
          } pt-20 w-full`}
        >
          <div className={`${styles['sharing-social-media__caption']} w-full text-center mb-10`}>
            Comparte tu creación
            <br />
            en redes sociales
            <br />
            con el numeral:
          </div>
          <div className="flex justify-center mb-8">
            <div className={`${styles['sharing-social-media__hashtag']}`}>#ArtistaDeArchivoBPP</div>
          </div>

          <div
            className={`${styles['sharing-social-media__social-media']} w-full flex gap-x-8 justify-center`}
          >
            <img
              onClick={() => handleShare('instagram')}
              className="cursor-pointer"
              src={instagramIcon}
              alt="Instagram"
            />
            <img
              onClick={() => handleShare('facebook')}
              src={facebookIcon}
              className="cursor-pointer"
              alt="Facebook"
            />
            <img
              onClick={() => handleShare('twitter')}
              src={twitterIcon}
              className="cursor-pointer"
              alt="Twitter"
            />
          </div>

          <ShowIf condition={!!imgPublicUrl}>
            <Paragraph
              className="text-center mt-5 font-dm-sans"
              copyable={{ tooltips: ['Copiar', 'Copiado'] }}
            >
              {imgPublicUrl}
            </Paragraph>
          </ShowIf>
        </div>
      </div>
    </Modal>
  );
}

export default SharingSocialMedia;
